export const SUPPORT_EMAIL = "support@appfire.com";
export const PRIVACY_POLICY = "https://appfire.com/privacy-policy";
export const SUPPORT_URL = "https://apps.appf.re/support-portal";
export const DOCUMENTATION = "https://apps.appf.re/gcc-quick-start";
